export const larosateOptions = [
  'Chalmers tekniska högskola',
  'Göteborgs universitet',
  'Göteborgs universitet/SIK, Institutet för Livsmedel och Bioteknik',
  'Helsingfors universitet',
  'Helsingfors',
  'Högskolan i Kalmar',
  'Karolinska institutet',
  'KTH',
  'Kungliga Tekniska högskolan',
  'Linköpings universitet',
  'Linneuniversitetet',
  'LinnÉuniversitetet',
  'Luleå tekniska universitet',
  'Lunds universitet',
  'Lunds universitet/Lund tekniska högskola',
  'Mittuniversitetet',
  'Mälardalens högskola',
  'SIK/Göteborgs universitet',
  'SLU',
  'Stockholms universitet',
  'Sveriges lantbruksuniversitet',
  'Södertörns högskola och KTH',
  'Södertörns högskola',
  'Umeå universitet',
  'Uppsala universitet',
  'Åbo Akademi',
  'Örebro universitet',
]

export const statusOptions = [
  {
    name: 'online',
    title: 'Online',
  },
  {
    name: 'offline',
    title: 'Offline',
  },
]

export const lanstyrelseOptions = [
  'Blekinge',
  'Dalarna',
  'Gotland',
  'Gävleborg',
  'Halland',
  'Jämtland',
  'Jönköping',
  'Kalmar',
  'Kronoberg',
  'Norrbotten',
  'Skåne',
  'Stockholm',
  'Södermanland',
  'Uppsala',
  'Värmland',
  'Västerbotten',
  'Västernorrland',
  'Västmanland',
  'Västra Götaland',
  'Örebro',
  'Östergötland',
]

export const orapSourceOptions = [
  'Naturvårdsverket, Havs- och vattenmyndigheten',
  'Academies',
  'AgriFood Economics CentreAmbioAnthesisAquaBiotaArctic CouncilArtDatabanken SLU',
  'ArtDatabanken, SLU',
  'Baltic EyeBaltic Sea 2020',
  'BalticSea2020BalticSTERNBalticWaters2030',
  'Boston Consulting Group',
  'Centrum för biologisk mångfald, SLU',
  'EarthscanEASACEEA EEA-Europeiska miljöbyrån',
  'Energimyndigheten och Svenskt kunskapscentrum för förnybara drivmedel',
  'Europaparlamentet',
  'European Commission',
  'Europeiska revisionsrätten',
  'FAOFederal Agency for Nature Conservation',
  'Finansdepartementet',
  'Finnish Environment Institute',
  'Finnish Environment Institute and Ministry of the Environment',
  'FiskeriverketFNFN:s livsmedels- och jordbruksorganisation, FAO',
  'FN:s världsmeteorologiska organisation WMO',
  'FNs klimatpanel IPCC',
  'Food and Agriculture Organization of the Unitred NationsFormasFormas, Havs- och vattenmyndigheten och SMHI',
  'Forskningsprogrammet AquAliens',
  'Forskningsrådet Formas',
  'FörsvarsmaktenGöteborgs naturhistoriska museum',
  'GreenpeaceGreppa Näringen',
  'Gullers förlagHåll Sverige rent',
  'Göteborgs universitet',
  'Hav möter landHav och Samhälle, Göteborgs Universitet',
  'Havforskningsinstituttet',
  'Havs och vattenmyndigheten',
  'Havs- och vattenmyndigheten',
  'Havs- och vattenmyndigheten, ArtDatabanken SLU',
  'Havs- och Vattenmyndigheten, Jordbruksverket',
  'Havsmiljöinstitutet',
  'HelcomHELCOM, Baltic Earth',
  'Högskolan i Kalmar',
  'Högskolan på Gotland',
  'ICESInstitut fur Ostseeforschung, IOW, Warnemunde',
  'Institutet för Framtidsstudier',
  'International Journal of Climatology',
  'International Union for Conservation of Nature (IUCN)Interreg BA-projektet Kvarken flada',
  'IPBES och IPCCIPCCIUCNIVLIVL Svenska miljöinstitutet',
  'IVL Svenska Miljöinstitutet',
  'JordbruksdepartementetJordbruksdepartementet, Svenska FAO-kommitténJordbruksverket',
  'Kemikalieinspektionen',
  'Kontaktgrupp Hav',
  'Kungliga skogs- och lantbruksakademien',
  'Kungliga vetenskapsakademien',
  'Kvarken Flada, Interreg Botnia Atlantica',
  'Livsmedelsverket',
  'Luftförorenings- och klimatsekretariatet',
  'Lunds universitet',
  'Marine Stewardship Council',
  'Maritima klustret i västsverige',
  'Miljödepartementet, Havsplaneringsutredningen',
  'Miljödepartementet, Klimat- och sårbarhetsutredningen',
  'Miljödepartementet, MiljöforskningsberedningenMiljödepartementet, NäringsdepartementetMiljömålsberedningen',
  'MiljödepartementetMiljödepartementet, Havsmiljöutredningen',
  'MistraMistra EviEMNaturhistoriska Riksmuseet',
  'Naturhistoriska riksmuseet, SLU, Göteborgs universitet,',
  'Naturskyddsföreningen',
  'Naturvårdsverket',
  'Naturvårdsverket, Fiskeriverket',
  'Naturvårdsverket, Vindval',
  'Nordiska ministerrådet',
  'Nordiska ministerrådet, Nordisk Ministerråds sekretariat, Havgruppen(HAV)',
  'OceanaOrdfront förlag',
  'OsparRegeringenRegeringen, Miljödepartementet',
  'Regeringskansliet',
  'RiksdagenRiksrevisionenRISE',
  'SAPEA - the Science Advice mechanisms for Policy by European',
  'SCBSeagis 2.0Seas At RiskSGU-Sveriges geologiska undersökning',
  'SGU-Sveriges geologiska undersökning, Länsstyrelsen i',
  'SiepsSjöfartsverketSkärgårdsstiftelsen i Stockholms län',
  'SLU AquaSLU Artdatabanken',
  'SLU Institutionen för mark och miljöSMHISMHI, Naturvårdsverket',
  'SLUSLU - Institutionen för akvatiska resurser',
  'SpringerStatens geotekniska institut',
  'StatskontoretStockholms universitet',
  'Stockholms universitets Östersjöcentrum',
  'Stockholms universitets Östersjöcentrum och SMHI',
  'SVASvenskt Vatten Utveckling',
  'Sveriges geologiska undersökning',
  'Sveriges geologiska undersökning (SGU)',
  'Sveriges lantbruksuniversitet',
  'Sveriges lantbruksuniversitet (SLU)',
  'The London School of Economics and Political Science',
  'Transportstyrelsen',
  'Umeå universitet',
  'UNEP/CMS Secretariat',
  'UNEPUNEP, FAO och UNESCO',
  'University of Oxford, University of York, Greenpeace',
  'Uppsala universitet',
  'Utbildningsdepartementet, Globaliseringsrådet',
  'Vattenbrukscentrum Väst, Göteborgs universitet',
  'Vattenmyndigheterna',
  'VindvalWATERS WHO/UNEPWorldwatch Institute',
  'VärldsbankenVärldsmeteorologiorganisationen WMO',
  'Världsnaturfonden WWF',
  'Västernorrland',
  'WWF',
  'Öresundsvattensamarbetet',
]

export const ArtGroups = [
  {
    id: 0,
    name_sve: 'Visa alla',
  },
  {
    id: 1,
    name_sve: 'Alger',
  },
  {
    id: 2,
    name_sve: 'Fiskar',
  },
  {
    id: 3,
    name_sve: 'Däggdjur',
  },
  {
    id: 4,
    name_sve: 'Kräftdjur',
  },
  {
    id: 5,
    name_sve: 'Blötdjur',
  },
  {
    id: 6,
    name_sve: 'Maskar',
  },
  {
    id: 7,
    name_sve: 'Udda grupper',
  },
  {
    id: 8,
    name_sve: 'Plankton',
  },
  {
    id: 9,
    name_sve: 'Insekter',
  },
  {
    id: 10,
    name_sve: 'Fåglar',
  },
  {
    id: 11,
    name_sve: 'Osorterad',
  },
  {
    id: 12,
    name_sve: 'Tagghudingar',
  },
  {
    id: 13,
    name_sve: 'Nässeldjur',
  },
  {
    id: 14,
    name_sve: 'Sjöpungar',
  },
  {
    id: 15,
    name_sve: 'Växter',
  },
]

export const GeoAreas = [
  {
    id: 1,
    name: 'Norrbotten',
  },
  {
    id: 2,
    name: 'Västerbotten',
  },
  {
    id: 3,
    name: 'Västernorrland',
  },
  {
    id: 4,
    name: 'Gävleborg',
  },
  {
    id: 5,
    name: 'Uppsala',
  },
  {
    id: 6,
    name: 'Stockholm',
  },
  {
    id: 7,
    name: 'Södermanland',
  },
  {
    id: 8,
    name: 'Östergötland',
  },
  {
    id: 9,
    name: 'Gotland',
  },
  {
    id: 10,
    name: 'Kalmar',
  },
  {
    id: 11,
    name: 'Skåne',
  },
  {
    id: 12,
    name: 'Blekinge',
  },
  {
    id: 13,
    name: 'Halland',
  },
  {
    id: 14,
    name: 'Västra Götaland',
  },
]

export const LifeEnv = [
  { id: 1, name: 'Grunda mjuka bottnar' },
  { id: 2, name: 'Grunda klipp- och stenbottnar' },
  { id: 3, name: 'Det fria vattnet' },
  { id: 4, name: 'Djupa mjuka bottnar' },
  { id: 5, name: 'Djupa klipp- och stenbottnar' },
]

export const userRoleOptions = [
  {
    title: 'Användare',
    name: 'user',
  },
  {
    title: 'Administratör',
    name: 'admin',
  },
  {
    title: 'Utvecklare',
    name: 'developer',
  },
]